import { defineStore } from 'pinia'

export const IsLoading = defineStore({
    id: 'dp_planner_loading',
    state: () => {
        return { value: false }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
